import React from 'react';
import Tooltip from '@atlaskit/tooltip';
import { css } from '@emotion/core';

import { SPACE_TINY } from '@/styles';

const sloTypeLogoStyles = css`
  position: relative;
  margin-left: ${SPACE_TINY}px;
  top: 1px;
`;

const MimirLogo: React.FC = () => (
  <div css={sloTypeLogoStyles}>
    <Tooltip position="top" content="Mimir Datasource SLO Group">
      <img alt="/" width="20" src="/assets/logo-mimir.svg" />
    </Tooltip>
  </div>
);

export default MimirLogo;
